"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolidAuthnLogic = void 0;
var rdflib_1 = require("rdflib");
var authUtil_1 = require("./authUtil");
var debug = __importStar(require("../util/debug"));
var SolidAuthnLogic = /** @class */ (function () {
    function SolidAuthnLogic(solidAuthSession) {
        this.session = solidAuthSession;
    }
    Object.defineProperty(SolidAuthnLogic.prototype, "authSession", {
        // we created authSession getter because we want to access it as authn.authSession externally
        get: function () { return this.session; },
        enumerable: false,
        configurable: true
    });
    SolidAuthnLogic.prototype.currentUser = function () {
        var app = (0, authUtil_1.appContext)();
        if (app.viewingNoAuthPage) {
            return (0, rdflib_1.sym)(app.webId);
        }
        if (this && this.session && this.session.info && this.session.info.webId && this.session.info.isLoggedIn) {
            return (0, rdflib_1.sym)(this.session.info.webId);
        }
        return (0, authUtil_1.offlineTestID)(); // null unless testing
    };
    /**
     * Retrieves currently logged in webId from either
     * defaultTestUser or SolidAuth
     * Also activates a session after login
     * @param [setUserCallback] Optional callback
     * @returns Resolves with webId uri, if no callback provided
     */
    SolidAuthnLogic.prototype.checkUser = function (setUserCallback) {
        return __awaiter(this, void 0, void 0, function () {
            var preLoginRedirectHash, redirectUrl, postLoginRedirectHash, curUrl, me, webId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        preLoginRedirectHash = new URL(window.location.href).hash;
                        if (preLoginRedirectHash) {
                            window.localStorage.setItem('preLoginRedirectHash', preLoginRedirectHash);
                        }
                        this.session.onSessionRestore(function (url) {
                            if (document.location.toString() !== url)
                                history.replaceState(null, '', url);
                        });
                        redirectUrl = new URL(window.location.href);
                        redirectUrl.hash = '';
                        return [4 /*yield*/, this.session
                                .handleIncomingRedirect({
                                restorePreviousSession: true,
                                url: redirectUrl.href
                            })
                            // Check to see if a hash was stored in local storage
                        ];
                    case 1:
                        _a.sent();
                        postLoginRedirectHash = window.localStorage.getItem('preLoginRedirectHash');
                        if (postLoginRedirectHash) {
                            curUrl = new URL(window.location.href);
                            if (curUrl.hash !== postLoginRedirectHash) {
                                if (history.pushState) {
                                    // debug.log('Setting window.location.has using pushState')
                                    history.pushState(null, document.title, postLoginRedirectHash);
                                }
                                else {
                                    // debug.warn('Setting window.location.has using location.hash')
                                    location.hash = postLoginRedirectHash;
                                }
                                curUrl.hash = postLoginRedirectHash;
                            }
                            // See https://stackoverflow.com/questions/3870057/how-can-i-update-window-location-hash-without-jumping-the-document
                            // window.location.href = curUrl.toString()// @@ See https://developer.mozilla.org/en-US/docs/Web/API/Window/location
                            window.localStorage.setItem('preLoginRedirectHash', '');
                        }
                        me = (0, authUtil_1.offlineTestID)();
                        if (me) {
                            return [2 /*return*/, Promise.resolve(setUserCallback ? setUserCallback(me) : me)];
                        }
                        webId = this.webIdFromSession(this.session.info);
                        if (webId) {
                            me = this.saveUser(webId);
                        }
                        if (me) {
                            debug.log("(Logged in as ".concat(me, " by authentication)"));
                        }
                        return [2 /*return*/, Promise.resolve(setUserCallback ? setUserCallback(me) : me)];
                }
            });
        });
    };
    /**
     * Saves `webId` in `context.me`
     * @param webId
     * @param context
     *
     * @returns Returns the WebID, after setting it
     */
    SolidAuthnLogic.prototype.saveUser = function (webId, context) {
        var webIdUri;
        if (webId) {
            webIdUri = (typeof webId === 'string') ? webId : webId.uri;
            var me = (0, rdflib_1.namedNode)(webIdUri);
            if (context) {
                context.me = me;
            }
            return me;
        }
        return null;
    };
    /**
     * @returns {Promise<string|null>} Resolves with WebID URI or null
     */
    SolidAuthnLogic.prototype.webIdFromSession = function (session) {
        var webId = (session === null || session === void 0 ? void 0 : session.webId) && session.isLoggedIn ? session.webId : null;
        return webId;
    };
    return SolidAuthnLogic;
}());
exports.SolidAuthnLogic = SolidAuthnLogic;
//# sourceMappingURL=SolidAuthnLogic.js.map